type ClerkTokenGetter = () => Promise<string | null>;

const defaultClerkTokenGetter: ClerkTokenGetter = async () => null;

let clerkTokenGetter: ClerkTokenGetter = defaultClerkTokenGetter;

export const setClerkTokenGetter = (getter: ClerkTokenGetter) => {
  clerkTokenGetter = getter;
};

export const clearClerkTokenGetter = () => {
  clerkTokenGetter = defaultClerkTokenGetter;
};

export const getClerkToken = async () => {
  return clerkTokenGetter();
};
